// Use proxy in development to avoid CORS issues with cookies
const apiBaseUrl = process.env.NODE_ENV === 'production'
  ? `${window.location.origin}/api`
  : '' // Empty - simple proxy forwards all requests to backend

// For IdentityServer authority, we need the full backend URL
export const identityAuthority = process.env.NODE_ENV === 'production'
  ? `${window.location.origin}/api`
  : 'http://localhost:52675'

export default apiBaseUrl
